import { lazy } from 'react';
import DeveloperGuard from 'src/components/DeveloperGuard';

export const Routes = [
    {
        exact: true,
        path: '/management/ai-permissions',
        guard: DeveloperGuard,
        component: lazy(() => import('src/views/assistant/AIPermissionsView')),
    },
];
